//
//
//
//

export default {
  // TODO: Use one of PwrError or ErrorDisplay everywhere
  name: 'PwrError',
  props: {
    error: {
      default: null,
    },
  },
  computed: {
    show() {
      return this.message !== null;
    },
    message() {
      return this.$container.logger.processError(this.error);
    },
  },
};
